export default __webpack_public_path__ + "static/media/main-background.645a9b25.svg";